import {useFragment} from 'react-relay'
import {graphql} from 'relay-runtime'
import type {MilestoneRowMetadata$key} from './__generated__/MilestoneRowMetadata.graphql'
import styles from './RepositoryMilestone.module.css'
import {ProgressBar} from '@primer/react'
import {MilestoneRowMenu} from './MilestoneRowMenu'

type MilestoneRowMetadataProps = {
  milestone: MilestoneRowMetadata$key
}

export function MilestoneRowMetadata({milestone}: MilestoneRowMetadataProps) {
  const data = useFragment(
    graphql`
      fragment MilestoneRowMetadata on Milestone {
        ...MilestoneRowMenu
        progressPercentage
        issues {
          totalCount
        }
      }
    `,
    milestone,
  )

  const totalCount = data.issues?.totalCount || 0
  const closedIssues = Math.floor((totalCount * (data.progressPercentage || 0)) / 100.0)
  const openIssues = totalCount - closedIssues

  return (
    <div className={styles.progressSection}>
      <ProgressBar
        progress={Math.floor(data.progressPercentage)}
        aria-hidden="true"
        data-testid="milestone-metadata-progress-bar"
      />
      <MilestoneRowMenu milestone={data} />
      <div>
        <span>
          <span className={styles.progressPercentage}>{Math.floor(data.progressPercentage)}%</span> complete
        </span>
        <span data-testid="milestone-metadata-open-issues">
          <span className={styles.progressPercentage}>{openIssues}</span> open
        </span>
        <span data-testid="milestone-metadata-closed-issues">
          <span className={styles.progressPercentage}>{closedIssues}</span> closed
        </span>
      </div>
    </div>
  )
}

try{ MilestoneRowMetadata.displayName ||= 'MilestoneRowMetadata' } catch {}